import { BaseService } from './BaseService'
const TIME_PATH = '/mission-remaining-time'
class TimeService extends BaseService {
  getTimeList () {
    return this.get(TIME_PATH)
  }
}
export default new TimeService()
